export default {
      id: "logo_invert-usage",
      viewBox: "0 0 270 270",
      url: __webpack_public_path__ + "img/icons.85006585.svg#logo_invert",
      toString: function () {
        return this.url;
      }
    }